const candidateName = ({ firstName, middleName, lastName }) => {
    let name = "";
    name += firstName;
    if (middleName) {
        name += " " + middleName;
    }
    if (lastName) {
        name += " " + lastName;
    }
    return name;
}

const goToBoard = (context) => {
    context.$router.push({
        name: 'CandidateDashboard'
    })
}

const formatDate = (inputDate, format) => {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    format = format.replace("MM", month.toString().padStart(2, "0"));
    if (format.indexOf("yyyy") > -1) {
        format = format.replace("yyyy", year.toString());
    } else if (format.indexOf("yy") > -1) {
        format = format.replace("yy", year.toString().substr(2, 2));
    }
    format = format.replace("dd", day.toString().padStart(2, "0"));
    return format;
}

const formatMonthName = (inputDate)=>{
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "long" };
    const formattedDate = date.toLocaleDateString("en-US", options);
    return formattedDate;
}

const formatMonthNameShort = (inputDate)=>{
    const date = new Date(inputDate);
    const options = { year: "numeric", month: "short" };
    const formattedDate = date.toLocaleDateString("en-US", options);
    return formattedDate;
}

const resetForm=(context)=>{
    context.$store.commit("candidateVUEX/setData", null);
    context.$store.commit("candidateVUEX/setType", null);
    goToBoard(context);
}

const editData = (context, data, name)=>{
    context.$store.commit("candidateVUEX/setType", "edit");
    context.$store.commit("candidateVUEX/setData", data);
    context.$router.push({
        name:name,
    });
}

const capitalizeWords = (str) => {
    if (!str) return "";
	return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
}

module.exports = {
    candidateName,
    goToBoard,
    formatDate,
    resetForm,
    formatMonthName,
    formatMonthNameShort,
    editData,
    capitalizeWords
}